import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { IoPersonAddSharp } from "react-icons/io5";
import { IoIosMail } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
import { AiFillSignature } from "react-icons/ai";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { useRef, useState } from 'react';
import './App.css';
import { InputMask } from "primereact/inputmask";
import { FloatLabel } from 'primereact/floatlabel';
import { useNavigate } from "react-router-dom";
import { BsPersonVcardFill } from "react-icons/bs";
import { InputText } from "primereact/inputtext";
import Title from "./components/Title";
import Panel from "./components/Panel";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { BiLogInCircle } from "react-icons/bi";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import axios, { AxiosError } from "axios";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";

function SignUp() {
  const [nome, setNome] = useState('')
  const [cpf, setCPF] = useState('')
  const [celular, setCelular] = useState('')
  const [email, setEmail] = useState('')

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [cadastrando, setCadastrando] = useState<boolean>(false)
  const toastRef = useRef<Toast>(null)
  const signup = async () => {
    setLoading(true)
    confirm1()
  }
const title = (
  <Title
    title='CADASTRO DO SISTEMA'
    subtitle='Preencha corretamente as informações'
    icon={() => <IoPersonAddSharp style={{ marginLeft: 10, marginRight: 10 }} />}
  />
)

const footer = (
  <>
    <Button severity='success' style={{ display: 'flex', justifyContent: 'center', width: '100%' }} onClick={signup} disabled={!(nome&&cpf&&celular&&email)||loading}>
      {loading ? <ProgressSpinner style={{ width: '32px', height: '32px' }} /> : <>CADASTRAR <BiLogInCircle size={24} style={{ marginLeft: 10 }} />
      </>}
    </Button>
    <Button severity='secondary' style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: 5 }}
      onClick={() => navigate('/')}
    >
      VOLTAR <MdOutlineKeyboardBackspace style={{ marginLeft: 10 }} />
    </Button>
  </>
)

const confirm1 = () => {
  confirmDialog({
    group: 'headless',
    message: 'Deseja proceder com o cadastro?',
    header: 'Confirmação',
    icon: 'pi pi-exclamation-triangle',
    defaultFocus: 'accept',
    accept: confimaçãoCadastro,
    reject: () => { setLoading(false) },
    closable: false
  });
};
const confimaçãoCadastro = ()=>{
  //console.log(nome, cpf, celular, email)
  setCadastrando(true)
  axios.post('https://api.eletroposto.gearspark.com.br/api/autoregistro/', {
    nome: nome,
    cpf: cpf,
    celular: celular,
    email: email
  }).then((result: any)=>{
    console.log('CADASTRO', result)
    resetFields()
    toastRef.current?.show({severity: 'success', summary:'Novo usuário', detail: 'Cadastro realizado com sucesso, em instantes você receberá um WhatsApp com a senha para acesso!', life: 10000})
  }).catch((error: AxiosError)=>{
    console.error(error)
    toastRef.current?.show({severity: 'error', summary:'Novo usuário', detail: 'Erro ao realizar cadastro', life: 10000})
  }).finally(()=>{
    setLoading(false)
    setCadastrando(false)
  })
}
const resetFields = ()=>{
  setNome('')
  setCPF('')
  setCelular('')
  setEmail('')
}
return (
  <div style={{ border: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#999999' }}>
    <Toast ref={toastRef} position='center'></Toast>
    <Dialog onHide={()=>{console.log('hide disabled')}} visible={cadastrando} closable={false} draggable={false} contentStyle={{display: 'grid'}}>
      <a>CADASTRANDO USUÁRIO</a>
      <div style={{padding: '1rem', margin: 'auto'}}>
        <ProgressSpinner></ProgressSpinner>
      </div>
      <a style={{margin: 'auto'}}>AGUARDE</a>
    </Dialog>
    <Panel title={() => title} footer={() => footer} >
      <ConfirmDialog group="headless" style={{color:'white'}}/>
      <div className="p-inputgroup flex-1">
        <span className="p-inputgroup-addon">
          <AiFillSignature />

        </span>
        <FloatLabel>
          <InputText id="nome_input" value={nome} onChange={(e: any) => setNome(e.target.value)} />
          <label htmlFor="nome_input">NOME</label>
        </FloatLabel>
      </div>

      <div className="p-inputgroup flex-1" style={{ marginTop: 30 }}>
        <span className="p-inputgroup-addon">
          <BsPersonVcardFill />
        </span>
        <FloatLabel>
          <InputMask id="cpf_input" value={cpf} onChange={(e: any) => setCPF(e.target.value)} mask="999.999.999-99" />
          <label htmlFor="cpf_input">CPF</label>
        </FloatLabel>
      </div>

      <div className="p-inputgroup flex-1" style={{ marginTop: 30 }}>
        <span className="p-inputgroup-addon">
          <FaPhoneAlt />
        </span>
        <FloatLabel>
          <InputMask id="celular_input" value={celular} onChange={(e: any) => setCelular(e.target.value)} mask="(99) 99999-9999" />
          <label htmlFor="celular_input">CELULAR</label>
        </FloatLabel>
      </div>

      <div className="p-inputgroup flex-1" style={{ marginTop: 30 }}>
        <span className="p-inputgroup-addon">
          <IoIosMail />
        </span>
        <FloatLabel>
          <InputText id="email_input" value={email} onChange={(e: any) => setEmail(e.target.value)} />
          <label htmlFor="email_input">EMAIL</label>
        </FloatLabel>
      </div>
    </Panel>
  </div>
);
}

export default SignUp;
